var n=function(){};export{n as FormBaseValidation};
